import universal from 'react-universal-component';

export default universal(() => import('./HuddleSearch'));



// WEBPACK FOOTER //
// ./src/app/views/HuddleSearch/index.js